import Appliances from 'assets/icons/appliances.svg';
import Exterior from 'assets/icons/exterior.svg';
import HotCold from 'assets/icons/hotcold.svg';
import Plumbing from 'assets/icons/plumbing.svg';
import Utility from 'assets/icons/utility.svg';
import Window from 'assets/icons/window.svg';
import Cosmetics from 'assets/icons/paint-brush.svg';
import HealthSafety from 'assets/icons/health-safety.svg';
import SmartHome from 'assets/icons/smart-home.svg';
import Furniture from 'assets/icons/furniture.svg';

export enum ProductGroups {
  Appliances = 1,
  Exterior = 2,
  HeatingCooling = 3,
  Plumbing = 4,
  Utility = 5,
  HealthSafety = 6,
  Window = 7,
  Cosmetics = 8,
  Furniture = 9,
  SmartHome = 10
}

export const iconForGroup = (id: number): string => {
  switch (id) {
    case ProductGroups.Appliances:
      return Appliances;
    case ProductGroups.Cosmetics:
      return Cosmetics;
    case ProductGroups.Exterior:
      return Exterior;
    case ProductGroups.HealthSafety:
      return HealthSafety;
    case ProductGroups.HeatingCooling:
      return HotCold;
    case ProductGroups.Plumbing:
      return Plumbing;
    case ProductGroups.Utility:
      return Utility;
    case ProductGroups.Window:
      return Window;
    case ProductGroups.Furniture:
      return Furniture;
    case ProductGroups.SmartHome:
      return SmartHome;
  }
  return '';
};
